import CryptoJS from 'crypto-js';

/**
 * Generates a SHA-256 hash signature based on the provided parameters.
 *
 * @param {string} grantType - The type of grant, either "email" or "mobile".
 * @param {string} email - The email address (used when grantType is "email").
 * @param {string} countryCode - The country code (used when grantType is "mobile").
 * @param {string} mobileNumber - The mobile number (used when grantType is "mobile").
 * @returns {string} The SHA-256 hash signature as a hexadecimal string.
 */

export function generateSignature(grantType, email, countryCode, mobileNumber) {
  const input = `duet${grantType}${countryCode}${mobileNumber}${email}duet`;
  const hashValue = CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
  return hashValue;
}
